import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {

  providers: [
    MessageService,
    importProvidersFrom([BrowserAnimationsModule])
]
};
